Object.defineProperty(exports, '__esModule', { value: true });

var _isEmpty = require('lodash/isEmpty');
var axios = require('axios');
var _get = require('lodash/get');
var _hasIn = require('lodash/hasIn');
var Qs = require('qs');
var _extend = require('lodash/extend');
var _head = require('lodash/head');
var _isArray = require('lodash/isArray');
var _pick = require('lodash/pick');
var _cloneDeep = require('lodash/cloneDeep');
var _isBoolean = require('lodash/isBoolean');
var _isObject = require('lodash/isObject');
var _isString = require('lodash/isString');
var _isNumber = require('lodash/isNumber');
var reactRedux = require('react-redux');
var React = require('react');
var Overridable = require('react-overridable');
var semanticUiReact = require('semantic-ui-react');
var redux = require('redux');
var thunk = require('redux-thunk');
var _ = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _hasIn__default = /*#__PURE__*/_interopDefaultLegacy(_hasIn);
var Qs__default = /*#__PURE__*/_interopDefaultLegacy(Qs);
var _extend__default = /*#__PURE__*/_interopDefaultLegacy(_extend);
var _head__default = /*#__PURE__*/_interopDefaultLegacy(_head);
var _isArray__default = /*#__PURE__*/_interopDefaultLegacy(_isArray);
var _pick__default = /*#__PURE__*/_interopDefaultLegacy(_pick);
var _cloneDeep__default = /*#__PURE__*/_interopDefaultLegacy(_cloneDeep);
var _isBoolean__default = /*#__PURE__*/_interopDefaultLegacy(_isBoolean);
var _isObject__default = /*#__PURE__*/_interopDefaultLegacy(_isObject);
var _isString__default = /*#__PURE__*/_interopDefaultLegacy(_isString);
var _isNumber__default = /*#__PURE__*/_interopDefaultLegacy(_isNumber);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Overridable__default = /*#__PURE__*/_interopDefaultLegacy(Overridable);
var thunk__default = /*#__PURE__*/_interopDefaultLegacy(thunk);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class ESRequestSerializer {
  constructor() {
    this.serialize = this.serialize.bind(this);
  }

  /**
   * Return a serialized version of the app state `query` for the API backend.
   * @param {object} stateQuery the `query` state to serialize
   */
  serialize(stateQuery) {
    const {
      queryString,
      sortBy,
      sortOrder,
      page,
      size
    } = stateQuery;
    const bodyParams = {};
    if (!_isEmpty__default["default"](queryString)) {
      bodyParams["query"] = {
        query_string: {
          query: queryString
        }
      };
    }
    if (sortBy) {
      const sortObj = {};
      sortObj[sortBy] = sortOrder && sortOrder === "desc" ? "desc" : "asc";
      bodyParams["sort"] = sortObj;
    }
    if (size > 0) {
      bodyParams["size"] = size;
    }
    if (page > 0) {
      const s = size > 0 ? size : 0;
      const from = (page - 1) * s;
      bodyParams["from"] = from;
    }
    return bodyParams;
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

class ESResponseSerializer {
  constructor() {
    this.serialize = this.serialize.bind(this);
  }

  /**
   * Return a serialized version of the API backend response for the app state `results`.
   * @param {object} payload the backend response payload
   */
  serialize(payload) {
    const {
      aggregations,
      hits
    } = payload;
    return {
      aggregations: aggregations || {},
      hits: hits.hits.map(hit => hit._source),
      total: hits.total.value
    };
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/**
 * Custom errors to raise specific expcetions
 */

function RequestCancelledError() {}
RequestCancelledError.prototype = new Error();

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class ESSearchApi {
  constructor(config) {
    this.axiosConfig = _get__default["default"](config, "axios", {});
    this.validateAxiosConfig();
    this.initSerializers(config);
    this.initInterceptors(config);
    this.initAxios();
    this.search = this.search.bind(this);
    this.axiosCancelToken = axios__default["default"].CancelToken;
  }
  validateAxiosConfig() {
    if (!_hasIn__default["default"](this.axiosConfig, "url")) {
      throw new Error("ESSearchApi config: `node` field is required.");
    }
  }
  initInterceptors(config) {
    this.requestInterceptor = _get__default["default"](config, "interceptors.request", undefined);
    this.responseInterceptor = _get__default["default"](config, "interceptors.response", undefined);
  }
  initSerializers(config) {
    const requestSerializerCls = _get__default["default"](config, "es.requestSerializer", ESRequestSerializer);
    const responseSerializerCls = _get__default["default"](config, "es.responseSerializer", ESResponseSerializer);
    this.requestSerializer = new requestSerializerCls();
    this.responseSerializer = new responseSerializerCls();
  }
  initAxios() {
    this.http = axios__default["default"].create(this.axiosConfig);
    this.addInterceptors();
  }
  addInterceptors() {
    if (this.requestInterceptor) {
      this.http.interceptors.request.use(this.requestInterceptor.resolve, this.requestInterceptor.reject);
    }
    if (this.responseInterceptor) {
      this.http.interceptors.request.use(this.responseInterceptor.resolve, this.responseInterceptor.reject);
    }
  }

  /**
   * Perform the backend request to search and return the serialized list of results for the app state `results`.
   * @param {string} stateQuery the `query` state with the user input
   */
  async search(stateQuery) {
    // cancel any previous request in case it is still happening
    this.axiosCancel && this.axiosCancel.cancel();
    // generate a new cancel token for this request
    this.axiosCancel = this.axiosCancelToken.source();
    const payload = this.requestSerializer.serialize(stateQuery);
    try {
      const response = await this.http.request({
        url: this.axiosConfig.url,
        method: "POST",
        data: payload,
        cancelToken: this.axiosCancel.token
      });
      return this.responseSerializer.serialize(response.data);
    } catch (error) {
      if (axios__default["default"].isCancel(error)) {
        throw new RequestCancelledError();
      } else {
        throw error;
      }
    }
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/** Default backend request serializer */
class InvenioRequestSerializer {
  constructor() {
    this._addFilter = (filter, filterUrlParams) => {
      if (!Array.isArray(filter)) {
        throw new Error(`Filter value "${filter}" in query state must be an array.`);
      }
      if (!(filter.length === 2 || filter.length === 3)) {
        throw new Error(`Filter value "${filter}" in query state must be an array of 2 or 3 elements`);
      }
      const hasChild = filter.length === 3;
      var aggName = filter[0];
      var fieldValue = filter[1];
      if (hasChild) {
        if (!Array.isArray(filter[2])) {
          throw new Error(`Filter value "${filter[2]}" in query state must be an array.`);
        }
        fieldValue = fieldValue + "::" + filter[2][1];
      }
      if (aggName in filterUrlParams) {
        filterUrlParams[aggName].push(fieldValue);
      } else {
        filterUrlParams[aggName] = [fieldValue];
      }
    };
    this._addFilters = filters => {
      if (!Array.isArray(filters)) {
        throw new Error(`Filters query state "${filters}" must be an array.`);
      }
      /**
       * input: [
       *   [ 'type_agg', 'value1' ]
       *   [ 'type_agg', 'value2', [ 'subtype_agg', 'a value' ] ]
       * ]
       */
      const filterUrlParams = {};
      filters.forEach(filter => {
        this._addFilter(filter, filterUrlParams);
      });
      /**
       * output: {
       *  type_agg: [ 'value1', 'value2::a value' ]
       * }
       */
      return filterUrlParams;
    };
    this.serialize = this.serialize.bind(this);
  }
  /**
   * Return a serialized version of the app state `query` for the API backend.
   * @param {object} stateQuery the `query` state to serialize
   */
  serialize(stateQuery) {
    const {
      queryString,
      sortBy,
      sortOrder,
      page,
      size,
      filters,
      hiddenParams
    } = stateQuery;
    let getParams = {};
    if (queryString !== null) {
      getParams["q"] = queryString;
    }
    if (sortBy !== null) {
      getParams["sort"] = sortBy;
      if (sortOrder !== null) {
        getParams["sort"] = sortOrder === "desc" ? `-${sortBy}` : sortBy;
      }
    }
    if (page > 0) {
      getParams["page"] = page;
    }
    if (size > 0) {
      getParams["size"] = size;
    }
    if (!_isEmpty__default["default"](hiddenParams)) {
      _extend__default["default"](getParams, this._addFilters(hiddenParams));
    }
    const filterParams = this._addFilters(filters);
    _extend__default["default"](getParams, filterParams);
    return Qs__default["default"].stringify(getParams, {
      arrayFormat: "repeat"
    });
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/** Default backend response serializer */
class InvenioResponseSerializer {
  constructor() {
    this.serialize = this.serialize.bind(this);
  }

  /**
   * Return a serialized version of the API backend response for the app state `results`.
   * @param {object} payload the backend response payload
   */
  serialize(payload) {
    const {
      aggregations,
      hits,
      ...extras
    } = payload;
    return {
      aggregations: aggregations || {},
      hits: hits.hits,
      total: hits.total,
      extras: extras
    };
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/**
 * Return true if the first string starts and contains the second.
 * @param {string} first a string
 * @param {string} second a string
 */
function startsWith(first, second) {
  /* This is a bit tricky, since the verification should distinguish between the label and the children
  In other words:
  * 'q=type:hello&subtype:there' (or 'q=type:hello') starts with 'q=type:hello'
  * 'q=type:hello there' should not start with 'q=type:hello'
  So the check verifies that both terms are the same length, or that there is an '&' as soon as the second finishes
  */
  return first.indexOf(second) === 0 && (first.length === second.length || first.indexOf(second + "&") === 0);
}
function toString(array) {
  return Qs__default["default"].stringify({
    q: array
  });
}
function parse(str) {
  return Qs__default["default"].parse(str)["q"];
}
function removeLastChild(arr) {
  const hasChild = arr.length === 3;
  if (hasChild) {
    const result = [arr[0], arr[1]];
    const lastChild = removeLastChild(arr[2]);
    if (lastChild.length) {
      result.push(lastChild);
    }
    return result;
  }
  return [];
}
function updateFilter(queryFilter, stateFilters) {
  /**
   * convert query and state to strings so they can be compared
   */
  const strQuery = toString(queryFilter);
  const strStateFilters = stateFilters.map(stateObjQuery => toString(stateObjQuery));

  /**
   * filter out any state that starts with the query or any parent of the query
   * e.g. query = ['file_type', 'pdf']
   *      state = [[ 'file_type', 'pdf' ]]
   *      filtered = []
   *
   *      query = [ 'type', 'publication' ]
   *      state = [['type', 'publication', ['subtype', 'report' ]]
   *      filtered = []
   *
   *      query = ['type', 'publication', ['subtype', 'report']]]
   *      state = [[ 'type', 'publication' ]]
   *      filtered = []
   */
  let anyRemoved = false;
  const filteredStrStates = strStateFilters.filter(strStateFilter => {
    const childFilterExists = startsWith(strStateFilter, strQuery);
    const parentFilterExists = startsWith(strQuery, strStateFilter);
    if (childFilterExists && !anyRemoved) {
      anyRemoved = true;
    }
    return !childFilterExists && !parentFilterExists;
  });
  if (!anyRemoved) {
    /**
     * if nothing has been removed, it means it was not previously there, so
     * the user query has to be added.
     * e.g. query = ['type', 'publication', ['subtype', 'report']]
     *      state = []
     *      filtered = [['type', 'publication', ['subtype', 'report']]]
     */
    filteredStrStates.push(strQuery);
  } else {
    /**
     * if a filter has been removed, it might have been a child. Add its parent if it is the root parent.
     * e.g. query = ['type', 'publication', 'subtype', 'report']
     *      state = [['type', 'publication', ['subtype', 'report']]]
     *      filtered = [['type', 'publication']]
     */
    const hasChild = queryFilter.length === 3;
    if (hasChild) {
      const rootParentArr = removeLastChild(queryFilter);
      const rootParentArrStrQuery = toString(rootParentArr);
      const anotherChildFound = filteredStrStates.some(strStateFilter => {
        const childFilterExists = startsWith(strStateFilter, rootParentArrStrQuery);
        const parentFilterExists = startsWith(rootParentArrStrQuery, strStateFilter);
        return childFilterExists || parentFilterExists;
      });
      if (_isEmpty__default["default"](filteredStrStates) || !anotherChildFound) {
        filteredStrStates.push(rootParentArrStrQuery);
      }
    }
  }

  /**
   * convert back to lists
   */
  return filteredStrStates.map(strState => parse(strState));
}
const updateQueryFilters$1 = (queryFilter, stateFilters) => {
  if (_isEmpty__default["default"](queryFilter)) return;

  /** If we have one filter as query = ['file_type', 'pdf'] */
  if (!_isArray__default["default"](_head__default["default"](queryFilter))) {
    return updateFilter(queryFilter, stateFilters);
  }

  /** If we have an array of filters as query we apply the filters one by one.
   * e.g. query = [['file_type', 'pdf'], ['file_type', 'txt']]
   */
  let tempStateFilters = stateFilters;
  for (const filter of queryFilter) {
    tempStateFilters = updateFilter(filter, tempStateFilters);
  }
  return tempStateFilters;
};
const updateQueryState$1 = (oldState, newState, storeKeys) => {
  let pickedState = _pick__default["default"](newState, storeKeys);
  if (!_isEmpty__default["default"](pickedState.filters)) {
    pickedState["filters"] = updateQueryFilters$1(pickedState.filters, oldState.filters);
  }
  return pickedState;
};

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

const INITIAL_QUERY_STATE = {
  queryString: "",
  suggestions: [],
  sortBy: null,
  sortOrder: null,
  page: -1,
  size: -1,
  filters: [],
  hiddenParams: [],
  layout: null
};
const INITIAL_QUERY_STATE_KEYS = Object.keys(INITIAL_QUERY_STATE);
const INITIAL_RESULTS_STATE = {
  loading: false,
  data: {
    hits: [],
    total: 0,
    aggregations: {}
  },
  error: {}
};
const INITIAL_APP_STATE = {
  hasUserChangedSorting: false,
  initialSortBy: null,
  initialSortOrder: null
};

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2021 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/** Default backend request serializer for invenio-records-resources */
class InvenioRecordsResourcesRequestSerializer {
  constructor() {
    this._checkFilter = filter => {
      if (!Array.isArray(filter)) {
        throw new Error(`Filter value "${filter}" in query state must be an array.`);
      }
      if (!(filter.length === 2 || filter.length === 3)) {
        throw new Error(`Filter value "${filter}" in query state must be an array of 2 or 3 elements`);
      }
    };
    this._addFilter = (filter, filterUrlParams) => {
      this._checkFilter(filter);
      const aggName = filter[0];
      const fieldValue = filter[1];
      const hasChild = filter.length === 3;
      if (hasChild) {
        this._checkFilter(filter[2]);
      }
      if (aggName in filterUrlParams) {
        if (hasChild) {
          filterUrlParams[aggName].push(fieldValue + "::" + filter[2][1]);
        } else {
          filterUrlParams[aggName].push(fieldValue);
        }
      } else {
        if (hasChild) {
          filterUrlParams[aggName] = [fieldValue + "::" + filter[2][1]];
        } else {
          filterUrlParams[aggName] = [fieldValue];
        }
      }
    };
    this._addFilters = filters => {
      if (!Array.isArray(filters)) {
        throw new Error(`Filters query state "${filters}" must be an array.`);
      }
      /**
       * input: [
       *   [ 'type_agg', 'value1' ]
       *   [ 'type_agg', 'value2', [ 'subtype_agg', 'a value' ] ]
       * ]
       */
      const filterUrlParams = {};
      filters.forEach(filter => {
        this._addFilter(filter, filterUrlParams);
      });
      /**
       * output: {
       *  type_agg: ['value1', 'value2::a value']
       * }
       */

      return filterUrlParams;
    };
    this.serialize = this.serialize.bind(this);
  }
  /**
   * Return a serialized version of the app state `query` for the API backend.
   * @param {object} stateQuery the `query` state to serialize
   */
  serialize(stateQuery) {
    const {
      queryString,
      sortBy,
      sortOrder,
      page,
      size,
      filters,
      hiddenParams
    } = stateQuery;
    let getParams = {};
    if (queryString !== null) {
      getParams["q"] = queryString;
    }
    if (sortBy !== null) {
      getParams["sort"] = sortBy;
      if (sortOrder !== null) {
        getParams["sort"] = sortOrder === "desc" ? `-${sortBy}` : sortBy;
      }
    }
    if (page > 0) {
      getParams["page"] = page;
    }
    if (size > 0) {
      getParams["size"] = size;
    }
    if (!_isEmpty__default["default"](hiddenParams)) {
      _extend__default["default"](getParams, this._addFilters(hiddenParams));
    }
    const filterParams = this._addFilters(filters);
    _extend__default["default"](getParams, filterParams);
    return Qs__default["default"].stringify(getParams, {
      arrayFormat: "repeat"
    });
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class InvenioSearchApi {
  constructor(config) {
    this.axiosConfig = _get__default["default"](config, "axios", {});
    this.validateAxiosConfig();
    this.initSerializers(config);
    this.initInterceptors(config);
    this.initAxios();
    this.search = this.search.bind(this);
    this.axiosCancelToken = axios__default["default"].CancelToken;
  }
  validateAxiosConfig() {
    if (!_hasIn__default["default"](this.axiosConfig, "url")) {
      throw new Error("InvenioSearchApi config: `url` field is required.");
    }
  }
  initInterceptors(config) {
    this.requestInterceptor = _get__default["default"](config, "interceptors.request", undefined);
    this.responseInterceptor = _get__default["default"](config, "interceptors.response", undefined);
  }
  getSerializer(serializer) {
    const requestSerializerMap = {
      InvenioRecordsResourcesRequestSerializer: InvenioRecordsResourcesRequestSerializer,
      InvenioRequestSerializer: InvenioRequestSerializer
    };
    if (typeof serializer === "string") {
      return requestSerializerMap[serializer];
    } else {
      return serializer ? serializer : InvenioRequestSerializer;
    }
  }
  initSerializers(config) {
    var _config$invenio;
    const requestSerializerCls = this.getSerializer((_config$invenio = config.invenio) === null || _config$invenio === void 0 ? void 0 : _config$invenio.requestSerializer);
    const responseSerializerCls = _get__default["default"](config, "invenio.responseSerializer", InvenioResponseSerializer);
    this.requestSerializer = new requestSerializerCls();
    this.responseSerializer = new responseSerializerCls();
  }
  initAxios() {
    const axiosConfig = {
      paramsSerializer: this.requestSerializer.serialize,
      ...this.axiosConfig
    };
    this.http = axios__default["default"].create(axiosConfig);
    this.addInterceptors();
  }
  addInterceptors() {
    if (this.requestInterceptor) {
      this.http.interceptors.request.use(this.requestInterceptor.resolve, this.requestInterceptor.reject);
    }
    if (this.responseInterceptor) {
      this.http.interceptors.request.use(this.responseInterceptor.resolve, this.responseInterceptor.reject);
    }
  }

  /**
   * Perform the backend request to search and return the serialized list of results for the app state `results`.
   * @param {string} stateQuery the `query` state with the user input
   */
  async search(stateQuery) {
    // cancel any previous request in case it is still happening
    this.axiosCancel && this.axiosCancel.cancel();
    // generate a new cancel token for this request
    this.axiosCancel = this.axiosCancelToken.source();
    try {
      let response = await this.http.request({
        url: this.axiosConfig.url,
        params: stateQuery,
        cancelToken: this.axiosCancel.token
      });
      response = this.responseSerializer.serialize(response.data);
      const newQueryState = updateQueryState$1(stateQuery, response.extras, INITIAL_QUERY_STATE_KEYS);
      if (!_isEmpty__default["default"](newQueryState)) {
        response.newQueryState = newQueryState;
      }
      delete response.extras;
      return response;
    } catch (error) {
      if (axios__default["default"].isCancel(error)) {
        throw new RequestCancelledError();
      } else {
        throw error;
      }
    }
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class InvenioSuggestionRequestSerializer {
  constructor(queryField) {
    this.queryField = queryField;
    this.serialize = this.serialize.bind(this);
  }

  /**
   * Return a serialized version of the app state `query` for the API backend.
   * @param {object} stateQuery the `query` state to serialize
   */
  serialize(stateQuery) {
    const {
      suggestionString
    } = stateQuery;
    const getParams = {};
    if (suggestionString !== null) {
      getParams["q"] = this.queryField + ":" + suggestionString;
    }
    return Qs__default["default"].stringify(getParams, {
      arrayFormat: "repeat",
      encode: false
    });
  }
}
class InvenioSuggestionResponseSerializer {
  constructor(responseField) {
    this._serializeSuggestions = responseHits => {
      return Array.from(new Set(responseHits.map(hit => _get__default["default"](hit.metadata, this.responseFieldPath))));
    };
    this.responseFieldPath = responseField.split(".");
    this.serialize = this.serialize.bind(this);
  }
  /**
   * Return a serialized version of the API backend response for the app state `suggestions`.
   * @param {object} payload the backend response payload
   */
  serialize(payload) {
    return {
      suggestions: this._serializeSuggestions(payload.hits.hits || [])
    };
  }
}
class InvenioSuggestionApi extends InvenioSearchApi {
  validateConfig(config) {
    super.validateConfig(config);
    if (!_hasIn__default["default"](config, "invenio.suggestions.queryField")) {
      throw new Error("InvenioSuggestionApi config: `invenio.suggestions.queryField` is required.");
    }
    if (!_hasIn__default["default"](config, "invenio.suggestions.responseField")) {
      throw new Error("InvenioSuggestionApi config: `invenio.suggestions.queryField` is responseField.");
    }
  }
  initSerializers(config) {
    const requestSerializerCls = _get__default["default"](config, "invenio.requestSerializer", InvenioSuggestionRequestSerializer);
    const responseSerializerCls = _get__default["default"](config, "invenio.responseSerializer", InvenioSuggestionResponseSerializer);
    this.requestSerializer = new requestSerializerCls(config.invenio.suggestions.queryField);
    this.responseSerializer = new responseSerializerCls(config.invenio.suggestions.responseField);
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/** Default implementation for a param validator class */
class UrlParamValidator {
  constructor() {
    /**
     * Return true if the param value is valid, false otherwise
     * @param {object} urlHandler the url handler
     * @param {string} key the parameter key
     * @param {string} value the parameter value
     */
    this.isValid = (urlHandler, key, value) => {
      switch (key) {
        case "queryString":
        case "sortBy":
          return true;
        case "sortOrder":
          return ["asc", "desc"].includes(value);
        case "page":
        case "size":
          return _isNumber__default["default"](value) && value > 0;
        case "layout":
          return ["grid", "list"].includes(value);
        case "filters":
        case "hiddenParams":
          {
            const array = _isArray__default["default"](value) ? value : [value];
            const cKvSep = ":",
              cChildSep = urlHandler.urlFilterSeparator;
            const pLiteral = `[^\\${cKvSep}\\${cChildSep}]*`,
              pKeyValue = `${pLiteral}\\${cKvSep}${pLiteral}`,
              pAll = `${pKeyValue}(\\${cChildSep}${pKeyValue})*`;
            const regex = new RegExp(`^${pAll}$`);
            return array.every(filter => String(filter).match(regex));
          }
        default:
          return false;
      }
    };
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const pushHistory = query => {
  if (window.history.pushState) {
    window.history.pushState({
      path: query
    }, "", query);
  }
};
const replaceHistory = query => {
  if (window.history.replaceState) {
    window.history.replaceState({
      path: query
    }, "", query);
  }
};

/** Default URL parser implementation */
class UrlParser {
  constructor() {
    /**
     * Convert string to int for `page` and `size` params
     * @param {string} key the name of the param
     * @param {string} value the value of the param
     */
    this._convertValue = (key, value) => {
      switch (key) {
        case this.paramsMapping["page"]:
        case this.paramsMapping["size"]:
          return parseInt(value);
        default:
          return value;
      }
    };
    this.parse = this.parse.bind(this);
    this.paramsMapping = {};
  }
  set urlParamsMapping(mapping) {
    this.paramsMapping = mapping;
  }
  /**
   * Parse the URL query string and return an object with all the params.
   * @param {string} queryString the query string to parse
   */
  parse() {
    let queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    const parsedParams = Qs__default["default"].parse(queryString, {
      ignoreQueryPrefix: true
    });
    const params = {};
    Object.entries(parsedParams).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      params[key] = this._convertValue(key, value);
    });
    return params;
  }
}

/** Object responsible to update the URL query string and parse it to update the app state */
class UrlHandlerApi {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /**
     * Map filters from list to string that is human readable
     * [ 'type', 'photo', [ 'subtype', 'png' ]] => type:photo+subtype:png
     */
    this._filterListToString = filter => {
      const childFilter = filter.length === 3 ? this.urlFilterSeparator.concat(this._filterListToString(filter[2])) : "";
      return `${filter[0]}:${filter[1]}${childFilter}`;
    };
    /**
     * Map each query state field to an URL param
     */
    this._mapQueryStateToUrlParams = queryState => {
      const params = {};
      Object.keys(queryState).filter(stateKey => stateKey in this.urlParamsMapping).filter(stateKey => {
        // filter out negative or null values
        if ((stateKey === "page" || stateKey === "size") && queryState[stateKey] <= 0) {
          return false;
        }
        if (stateKey === "hiddenParams") {
          return false;
        }
        return queryState[stateKey] !== null;
      }).forEach(stateKey => {
        const paramKey = this.urlParamsMapping[stateKey];
        if (stateKey === "filters") {
          params[paramKey] = queryState[stateKey].map(filter => this._filterListToString(filter));
        } else {
          params[paramKey] = queryState[stateKey];
        }
      });
      const keyComparator = (a, b) => {
        const q = "q"; // query parameter should appear first
        if (a === q) {
          return -1;
        } else if (b === q) {
          return 1;
        }
        return a.localeCompare(b);
      };

      // will omit undefined and null values from the query
      return Qs__default["default"].stringify(params, {
        addQueryPrefix: true,
        skipNulls: true,
        indices: false,
        // order for filters params is not important, remove indices
        sort: keyComparator
      });
    };
    /**
     * Map filters from string to list
     * type:photo+subtype:png => [ 'type', 'photo', [ 'subtype', 'png' ]]
     */
    this._filterStringToList = filterStr => {
      const childSepPos = filterStr.indexOf(this.urlFilterSeparator);
      const hasChild = childSepPos > -1;
      const aggNamePos = filterStr.indexOf(":");
      if (aggNamePos === -1) {
        throw new Error(`Filter "${filterStr}" not parsable. Format expected: "<agg name>:<value>"`);
      }
      const aggName = filterStr.slice(0, aggNamePos);
      const end = hasChild ? childSepPos : filterStr.length;
      const value = filterStr.slice(aggNamePos + 1, end);
      let filterList = [aggName, value];
      if (hasChild) {
        const childFilter = filterStr.slice(childSepPos + 1, filterStr.length);
        filterList.push(this._filterStringToList(childFilter));
      }
      return filterList;
    };
    /**
     * Map each URL param to a query state field
     */
    this._mapUrlParamsToQueryState = urlParamsObj => {
      const result = {};
      Object.keys(urlParamsObj).forEach(paramKey => {
        const queryStateKey = this.fromUrlParamsMapping[paramKey];
        if (this.urlParamValidator.isValid(this, queryStateKey, urlParamsObj[paramKey])) {
          result[queryStateKey] = urlParamsObj[paramKey];
          // custom transformation for filters
          if (queryStateKey === "filters") {
            if (!Array.isArray(urlParamsObj[paramKey])) {
              // if only 1 filter, create an array with one element
              urlParamsObj[paramKey] = [urlParamsObj[paramKey]];
            }
            result[queryStateKey] = urlParamsObj[paramKey].map(filter => this._filterStringToList(filter));
          }
        } else {
          console.warn(`URL parameter '${paramKey}' with value '${urlParamsObj[paramKey]}' is incorrect and was ignored.`);
        }
      });
      return result;
    };
    this._mergeParamsIntoState = (urlStateObj, queryState) => {
      const _queryState = _cloneDeep__default["default"](queryState);
      Object.keys(urlStateObj).forEach(stateKey => {
        _queryState[stateKey] = urlStateObj[stateKey];
      });
      return _queryState;
    };
    this.urlParamsMapping = _isObject__default["default"](config.urlParamsMapping) ? config.urlParamsMapping : {
      queryString: "q",
      sortBy: "sort",
      sortOrder: "order",
      page: "p",
      size: "s",
      layout: "l",
      filters: "f",
      hiddenParams: "hp"
    };
    this.keepHistory = config.keepHistory !== undefined ? config.keepHistory : true;
    if (!_isBoolean__default["default"](this.keepHistory)) {
      throw new Error(`"keepHistory configuration must be a boolean, ${this.keepHistory} provided.`);
    }
    this.urlFilterSeparator = config.urlFilterSeparator !== undefined ? config.urlFilterSeparator : "+";
    if (!_isString__default["default"](this.urlFilterSeparator)) {
      throw new Error(`"urlFilterSeparator configuration must be a string, ${this.urlFilterSeparator} provided.`);
    }
    this.urlParamValidator = config.urlParamValidator || new UrlParamValidator();
    this.urlParser = config.urlParser || new UrlParser();
    this.urlParser.urlParamsMapping = this.urlParamsMapping;

    // build the serializer from URL params to Query state by flipping the urlParamsMapping
    this.fromUrlParamsMapping = {};
    Object.keys(this.urlParamsMapping).forEach(stateKey => {
      this.fromUrlParamsMapping[this.urlParamsMapping[stateKey]] = stateKey;
    });
    this.get = this.get.bind(this);
    this.set = this.set.bind(this);
    this.replace = this.replace.bind(this);
  }
  /**
   * Return a new version of the given `query` state with updated values parsed from the URL query string.
   * @param {object} queryState the `query` state
   */
  get(queryState) {
    const urlParamsObj = this.urlParser.parse(window.location.search);
    const urlStateObj = this._mapUrlParamsToQueryState(urlParamsObj);
    const newQueryState = this._mergeParamsIntoState(urlStateObj, queryState);
    const newUrlParams = this._mapQueryStateToUrlParams(newQueryState);
    replaceHistory(newUrlParams);
    return newQueryState;
  }

  /**
   * Update the URL query string parameters from the given `query` state
   * @param {object} stateQuery the `query` state
   */
  set(stateQuery) {
    if (this.keepHistory) {
      const newUrlParams = this._mapQueryStateToUrlParams(stateQuery);
      pushHistory(newUrlParams);
    } else {
      this.replace(stateQuery);
    }
  }

  /**
   * Replace the URL query string parameters from the given `query` state
   * @param {object} stateQuery the `query` state
   */
  replace(stateQuery) {
    const newUrlParams = this._mapQueryStateToUrlParams(stateQuery);
    replaceHistory(newUrlParams);
  }
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

const SET_QUERY_COMPONENT_INITIAL_STATE = "SET_QUERY_COMPONENT_INITIAL_STATE";
const SET_QUERY_STRING = "SET_QUERY_STRING";
const SET_QUERY_SORTING = "SET_QUERY_SORTING";
const SET_QUERY_SORT_BY = "SET_QUERY_SORT_BY";
const SET_QUERY_SORT_ORDER = "SET_QUERY_SORT_ORDER";
const SET_QUERY_STATE = "SET_QUERY_STATE";
const SET_QUERY_PAGINATION_PAGE = "SET_QUERY_PAGINATION_PAGE";
const SET_QUERY_PAGINATION_SIZE = "SET_QUERY_PAGINATION_SIZE";
const SET_QUERY_FILTERS = "SET_QUERY_FILTERS";
const SET_QUERY_SUGGESTIONS = "SET_QUERY_SUGGESTIONS";
const SET_SUGGESTION_STRING = "SET_SUGGESTION_STRING";
const CLEAR_QUERY_SUGGESTIONS = "CLEAR_QUERY_SUGGESTIONS";
const RESULTS_LOADING = "RESULTS_LOADING";
const RESULTS_FETCH_SUCCESS = "RESULTS_FETCH_SUCCESS";
const RESULTS_FETCH_ERROR = "RESULTS_FETCH_ERROR";
const RESULTS_UPDATE_LAYOUT = "RESULTS_UPDATE_LAYOUT";
const RESET_QUERY = "RESET_QUERY";

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const onAppInitialized = searchOnInit => {
  return dispatch => {
    if (searchOnInit) {
      dispatch(executeQuery({
        shouldUpdateUrlQueryString: false,
        shouldReplaceUrlQueryString: true
      }));
    }
  };
};
const updateQueryState = queryState => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_STATE,
      payload: queryState
    });
    dispatch(executeQuery());
  };
};
const updateQueryString = queryString => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_STRING,
      payload: queryString
    });
    dispatch(executeQuery());
  };
};
const updateQuerySorting = (sortByValue, sortOrderValue) => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_SORTING,
      payload: {
        sortBy: sortByValue,
        sortOrder: sortOrderValue
      }
    });
    dispatch(executeQuery());
  };
};
const updateQuerySortBy = sortByValue => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_SORT_BY,
      payload: sortByValue
    });
    dispatch(executeQuery());
  };
};
const updateQuerySortOrder = sortOrderValue => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_SORT_ORDER,
      payload: sortOrderValue
    });
    dispatch(executeQuery());
  };
};
const updateQueryPaginationPage = page => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_PAGINATION_PAGE,
      payload: page
    });
    dispatch(executeQuery());
  };
};
const updateQueryPaginationSize = size => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_PAGINATION_SIZE,
      payload: size
    });
    dispatch(executeQuery());
  };
};
const updateQueryFilters = filters => {
  return dispatch => {
    dispatch({
      type: SET_QUERY_FILTERS,
      payload: filters
    });
    dispatch(executeQuery());
  };
};
const updateResultsLayout = layout => {
  return async (dispatch, getState, config) => {
    const urlHandlerApi = config.urlHandlerApi;
    if (urlHandlerApi) {
      await dispatch({
        type: RESULTS_UPDATE_LAYOUT,
        payload: layout
      });
      const newStateQuery = getState().query;
      urlHandlerApi.set(newStateQuery);
    } else {
      dispatch({
        type: RESULTS_UPDATE_LAYOUT,
        payload: layout
      });
    }
  };
};
const resetQuery = () => {
  return (dispatch, getState, config) => {
    dispatch({
      type: RESET_QUERY,
      payload: {
        queryString: "",
        page: 1,
        filters: [],
        ...config.initialQueryState
      }
    });
    dispatch(executeQuery());
  };
};

/**
 * Update URL parameters.
 * @param {object} queryState - current query state
 * @param {object} appConfig - app config
 * @param {boolean} shouldReplaceUrlQueryString - true if should replace the last browser history state
 * @param {boolean} shouldUpdateUrlQueryString - true if it should add a new browser history state
 */
const updateURLParameters = (queryState, appConfig, shouldReplaceUrlQueryString, shouldUpdateUrlQueryString) => {
  const urlHandlerApi = appConfig.urlHandlerApi;
  if (urlHandlerApi) {
    if (shouldReplaceUrlQueryString) {
      urlHandlerApi.replace(queryState);
    } else if (shouldUpdateUrlQueryString) {
      urlHandlerApi.set(queryState);
    }
  }
};

/**
 * Update query state and URL args with the new query state given by the backend response.
 * @param {object} response - API response
 * @param {func} dispatch - Redux `dispath` function
 * @param {func} getState - function to get the Redux state
 * @param {object} appConfig - app config
 */
const updateQueryStateAfterResponse = (response, dispatch, getState, appConfig) => {
  const prevState = getState().query;
  dispatch({
    type: SET_QUERY_STATE,
    payload: {
      ...prevState,
      ...response.newQueryState
    }
  });
  const updatedQueryState = _cloneDeep__default["default"](getState().query);
  const urlHandlerApi = appConfig.urlHandlerApi;
  if (urlHandlerApi) {
    // Replace the URL args with the response new query state
    urlHandlerApi.replace(updatedQueryState);
  }
  delete response.newStateQuery;
  return response;
};
const updateSearchSorting = (queryState, appState, appConfig, dispatch) => {
  function getSearchSortingOnQueryString(queryState, appState, appConfig, dispatch) {
    const isQueryStringEmpty = queryState.queryString === "";
    if (isQueryStringEmpty) {
      queryState.sortBy = appConfig.defaultSortingOnEmptyQueryString.sortBy;
      queryState.sortOrder = appConfig.defaultSortingOnEmptyQueryString.sortOrder;
    } else {
      queryState.sortBy = appState.initialSortBy;
      queryState.sortOrder = appState.initialSortOrder;
    }
    dispatch({
      type: SET_QUERY_STATE,
      payload: queryState
    });
  }
  function getSearchSorting(queryState, appState, appConfig, dispatch) {
    const userHasChangedSorting = appState.hasUserChangedSorting;
    if (!userHasChangedSorting) {
      // change sorting only if user did not change it
      getSearchSortingOnQueryString(queryState, appState, appConfig, dispatch);
    }
  }

  // when the `defaultSortingOnEmptyQueryString` config is not defined,
  // return the current query state
  const defaultSortingDefined = !_isEmpty__default["default"](appConfig.defaultSortingOnEmptyQueryString);
  if (defaultSortingDefined) {
    // when the `defaultSortingOnEmptyQueryString` config is defined,
    // evaluate if the sorting should be automatically changed
    getSearchSorting(queryState, appState, appConfig, dispatch);
  }
};

/**
 * Execute search API request with current query state and update results state with response.
 * @param {object} options - `shouldUpdateUrlQueryString` and `shouldReplaceUrlQueryString` to choose if the
 *                           browser history state should be updated with the current query state.
 */
const executeQuery = function () {
  let {
    shouldUpdateUrlQueryString = true,
    shouldReplaceUrlQueryString = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async (dispatch, getState, config) => {
    const appState = getState().app;
    let queryState = _cloneDeep__default["default"](getState().query);
    updateSearchSorting(queryState, appState, config, dispatch);

    // fetch latest query state
    queryState = _cloneDeep__default["default"](getState().query);
    updateURLParameters(queryState, config, shouldReplaceUrlQueryString, shouldUpdateUrlQueryString);
    dispatch({
      type: RESULTS_LOADING
    });
    try {
      const searchApi = config.searchApi;
      let response = await searchApi.search(queryState);
      if ("newQueryState" in response) {
        response = updateQueryStateAfterResponse(_cloneDeep__default["default"](response), dispatch, getState, config);
      }
      dispatch({
        type: RESULTS_FETCH_SUCCESS,
        payload: {
          aggregations: response.aggregations,
          hits: response.hits,
          total: response.total
        }
      });
    } catch (error) {
      if (error instanceof RequestCancelledError) {
        // do nothing when the request was cancelled, another request is normally already happening
        console.debug(error);
        return;
      } else {
        console.error(error);
        dispatch({
          type: RESULTS_FETCH_ERROR,
          payload: {
            error: error
          }
        });
      }
    }
  };
};
const updateSuggestions = suggestionString => {
  return dispatch => {
    dispatch({
      type: SET_SUGGESTION_STRING,
      payload: suggestionString
    });
    dispatch(executeSuggestionQuery());
  };
};
const executeSuggestionQuery = () => {
  return async (dispatch, getState, config) => {
    const queryState = _cloneDeep__default["default"](getState().query);
    const suggestionApi = config.suggestionApi;
    try {
      const response = await suggestionApi.search(queryState);
      dispatch({
        type: SET_QUERY_SUGGESTIONS,
        payload: {
          suggestions: response.suggestions
        }
      });
    } catch (reason) {
      console.error("Could not load suggestions due to: " + reason);
    }
  };
};
const clearSuggestions = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_QUERY_SUGGESTIONS,
      payload: {
        suggestions: []
      }
    });
  };
};
const updateQueryStateFromUrl = () => {
  return (dispatch, getState, config) => {
    if (config.urlHandlerApi) {
      const newState = config.urlHandlerApi.get(config.initialQueryState);
      dispatch({
        type: SET_QUERY_STATE,
        payload: newState
      });
      dispatch(executeQuery({
        shouldReplaceUrlQueryString: true
      }));
    }
  };
};

const AppContext = /*#__PURE__*/React__default["default"].createContext({});

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const appReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_QUERY_SORTING:
      return {
        ...state,
        hasUserChangedSorting: true
      };
    case SET_QUERY_SORT_BY:
      return {
        ...state,
        hasUserChangedSorting: true
      };
    case SET_QUERY_SORT_ORDER:
      return {
        ...state,
        hasUserChangedSorting: true
      };
    default:
      return state;
  }
};

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2019 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const queryReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_QUERY_STRING:
      return {
        ...state,
        queryString: action.payload,
        page: 1
      };
    case SET_QUERY_SORTING:
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
        _sortUserChanged: true,
        page: 1
      };
    case SET_QUERY_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
        _sortUserChanged: true,
        page: 1
      };
    case SET_QUERY_SORT_ORDER:
      return {
        ...state,
        sortOrder: action.payload,
        _sortUserChanged: true,
        page: 1
      };
    case SET_QUERY_PAGINATION_PAGE:
      return {
        ...state,
        page: action.payload
      };
    case SET_QUERY_PAGINATION_SIZE:
      return {
        ...state,
        size: action.payload,
        page: 1
      };
    case SET_QUERY_FILTERS:
      {
        return {
          ...state,
          page: 1,
          filters: updateQueryFilters$1(action.payload, state.filters)
        };
      }
    case SET_QUERY_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.payload.suggestions
      };
    case CLEAR_QUERY_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.payload.suggestions
      };
    case SET_SUGGESTION_STRING:
      return {
        ...state,
        suggestionString: action.payload
      };
    case SET_QUERY_COMPONENT_INITIAL_STATE:
      return {
        ...state,
        ...action.payload
      };
    case SET_QUERY_STATE:
      return {
        ...state,
        ...INITIAL_QUERY_STATE,
        ...updateQueryState$1(INITIAL_QUERY_STATE, action.payload, INITIAL_QUERY_STATE_KEYS)
      };
    case RESULTS_UPDATE_LAYOUT:
      return {
        ...state,
        layout: action.payload
      };
    case RESET_QUERY:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const resultsReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case RESULTS_LOADING:
      return {
        ...state,
        loading: true,
        data: {
          ...state.data
        }
      };
    case RESULTS_FETCH_SUCCESS:
      return {
        loading: false,
        data: {
          ...state.data,
          aggregations: action.payload.aggregations,
          hits: action.payload.hits,
          total: action.payload.total
        },
        error: {}
      };
    case RESULTS_FETCH_ERROR:
      return {
        loading: false,
        data: {
          ...state.data,
          aggregations: {},
          hits: [],
          total: 0
        },
        error: action.payload.error
      };
    default:
      return state;
  }
};

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
var rootReducer = redux.combineReducers({
  app: appReducer,
  query: queryReducer,
  results: resultsReducer
});

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function isSortingDifferent(_ref, _ref2) {
  let {
    sortBy: sortBy1,
    sortOrder: sortOrder1
  } = _ref;
  let {
    sortBy: sortBy2,
    sortOrder: sortOrder2
  } = _ref2;
  const differentSortBy = sortBy1 !== sortBy2;
  const differentSortOrder = sortOrder1 !== sortOrder2;
  return differentSortBy || differentSortOrder;
}
function urlParamsChangedSorting(appConfig, initialQueryState, queryStateFromURLParams) {
  // check if the sorting has been changed by the URL params
  // it is not the initial or defaultOnEmpty values
  const differInitialSorting = isSortingDifferent(queryStateFromURLParams, initialQueryState);
  const isDefaultOnEmptyDefined = !_isEmpty__default["default"](appConfig.defaultSortingOnEmptyQueryString);
  let differDefaultOnEmtpy = false;
  if (isDefaultOnEmptyDefined) {
    differDefaultOnEmtpy = isSortingDifferent(queryStateFromURLParams, appConfig.defaultSortingOnEmptyQueryString);
  }
  const isDifferentThanInitialAndDefaultOnEmpty = differInitialSorting && differDefaultOnEmtpy;
  return isDifferentThanInitialAndDefaultOnEmpty;
}
function getInitialState(appConfig) {
  // update `query` state
  const initialQueryState = {
    ...INITIAL_QUERY_STATE,
    ...appConfig.initialQueryState
  };

  // update initial state depending on URL params values
  const queryStateFromURLParams = appConfig.urlHandlerApi ? appConfig.urlHandlerApi.get(initialQueryState) : initialQueryState;

  // the sorting value in URL params takes precedence
  // evaluate if URL params have sorting with a specific value
  // that is not initial or defaultOnEmpty
  const hasUserChangedSorting = urlParamsChangedSorting(appConfig, initialQueryState, queryStateFromURLParams);

  // update `app` state
  const initialAppState = {
    ...INITIAL_APP_STATE,
    hasUserChangedSorting: hasUserChangedSorting,
    initialSortBy: initialQueryState.sortBy,
    initialSortOrder: initialQueryState.sortOrder
  };

  // update `results` state
  const initialResultsState = {
    ...INITIAL_RESULTS_STATE,
    loading: appConfig.searchOnInit
  };
  return {
    app: initialAppState,
    query: queryStateFromURLParams,
    results: initialResultsState
  };
}
function createStoreWithConfig(appConfig) {
  const preloadedState = getInitialState(appConfig);
  return redux.createStore(rootReducer, preloadedState, redux.applyMiddleware(thunk__default["default"].withExtraArgument(appConfig)));
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

/**
 * Build namespaced unique identifier.
 * @param {string} elementName component element name
 * @param {string} overridableId unique identifier passed as prop to overridable component
 * @param {string} appName the app name
 * @return {string} the unique id string with the format 'appName.elementName.overridableId'
 */
function buildUID(elementName) {
  let overridableId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  let appName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  const _overridableId = overridableId ? `.${overridableId}` : "";
  const _appName = appName ? `${appName}.` : "";
  return `${_appName}${elementName}${_overridableId}`;
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class Bootstrap$1 extends React.Component {
  constructor(props) {
    super(props);
    this.updateQueryState = query => {
      const {
        updateQueryState
      } = this.props;
      updateQueryState(query);
    };
    this.onQueryChanged = _ref => {
      let {
        detail: payload
      } = _ref;
      const {
        appName
      } = this.context;
      const appNameNotDefined = !appName;
      if (appNameNotDefined) {
        this.updateQueryState(payload.searchQuery);
      } else {
        const eventRecipient = payload.appName;
        const sameName = eventRecipient === appName;
        if (sameName) {
          this.updateQueryState(payload.searchQuery);
        } else {
          console.debug(`React-SearchKit '${appName}': ignoring event sent for app '${eventRecipient}'`);
        }
      }
    };
    this.searchOnInit = props.searchOnInit;
    this.eventListenerEnabled = props.eventListenerEnabled;
    this.onAppInitialized = props.onAppInitialized;
    this.searchOnUrlQueryStringChanged = props.searchOnUrlQueryStringChanged;
  }
  componentDidMount() {
    if (this.eventListenerEnabled) {
      window.addEventListener("queryChanged", this.onQueryChanged);
    }
    window.onpopstate = () => {
      this.searchOnUrlQueryStringChanged();
    };
    this.onAppInitialized(this.searchOnInit);
  }
  componentWillUnmount() {
    window.onpopstate = () => {};
    window.removeEventListener("queryChanged", this.onQueryChanged);
  }
  render() {
    const {
      children
    } = this.props;
    return children;
  }
}
Bootstrap$1.defaultProps = {
  searchOnInit: true,
  eventListenerEnabled: false
};
Bootstrap$1.contextType = AppContext;
var BootstrapComponent = Overridable__default["default"].component("Bootstrap", Bootstrap$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$c = dispatch => ({
  onAppInitialized: searchOnInit => dispatch(onAppInitialized(searchOnInit)),
  updateQueryState: queryState => dispatch(updateQueryState(queryState)),
  searchOnUrlQueryStringChanged: () => dispatch(updateQueryStateFromUrl())
});
const Bootstrap = reactRedux.connect(null, mapDispatchToProps$c)(BootstrapComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class ReactSearchKit extends React.Component {
  constructor(props) {
    super(props);
    const appConfig = {
      searchApi: props.searchApi,
      suggestionApi: props.suggestionApi,
      urlHandlerApi: props.urlHandlerApi.enabled ? props.urlHandlerApi.customHandler || new UrlHandlerApi(props.urlHandlerApi.overrideConfig) : null,
      searchOnInit: props.searchOnInit,
      initialQueryState: props.initialQueryState,
      defaultSortingOnEmptyQueryString: props.defaultSortingOnEmptyQueryString
    };
    this.store = createStoreWithConfig(appConfig);
    this.appName = props.appName;
    this.eventListenerEnabled = props.eventListenerEnabled;
    this.componentIndex = 0;
  }
  render() {
    const {
      appName,
      children,
      eventListenerEnabled,
      overridableId,
      searchOnInit
    } = this.props;
    const context = {
      appName,
      buildUID: (element, overrideId) => buildUID(element, overrideId, appName),
      /* This is an internal function that will be used to create id for the checkboxes and labels, ensuring that
          they are unique */
      nextComponentIndex: () => `${this.appName}_${this.componentIndex++}`
    };
    const _overridableId = buildUID("ReactSearchKit.children", overridableId, appName);
    return /*#__PURE__*/React__default["default"].createElement(AppContext.Provider, {
      value: context
    }, /*#__PURE__*/React__default["default"].createElement(reactRedux.Provider, {
      store: this.store
    }, /*#__PURE__*/React__default["default"].createElement(Bootstrap, {
      searchOnInit: searchOnInit,
      eventListenerEnabled: eventListenerEnabled
    }, /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
      id: _overridableId
    }, children))));
  }
}
ReactSearchKit.defaultProps = {
  suggestionApi: null,
  urlHandlerApi: {
    enabled: true,
    overrideConfig: {},
    customHandler: null
  },
  searchOnInit: true,
  appName: "",
  eventListenerEnabled: false,
  overridableId: "",
  initialQueryState: {},
  defaultSortingOnEmptyQueryString: {}
};
ReactSearchKit.contextType = AppContext;
var ReactSearchKit$1 = Overridable__default["default"].component("ReactSearchKit", ReactSearchKit);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class ActiveFilters$1 extends React.Component {
  constructor(props) {
    super(props);
    this._getLabel = filter => {
      const aggName = filter[0];
      let value = filter[1];
      let currentFilter = [aggName, value];
      const hasChild = filter.length === 3;
      if (hasChild) {
        const {
          label,
          activeFilter
        } = this._getLabel(filter[2]);
        value = `${value}.${label}`;
        currentFilter.push(activeFilter);
      }
      return {
        label: value,
        activeFilter: currentFilter
      };
    };
    this.updateQueryFilters = props.updateQueryFilters;
  }
  render() {
    const {
      filters,
      overridableId
    } = this.props;
    return !!filters.length && /*#__PURE__*/React__default["default"].createElement(Element$g, {
      filters: filters,
      removeActiveFilter: this.updateQueryFilters,
      getLabel: this._getLabel,
      overridableId: overridableId
    });
  }
}
ActiveFilters$1.defaultProps = {
  overridableId: ""
};
const Element$g = _ref => {
  let {
    overridableId,
    filters,
    removeActiveFilter,
    getLabel
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ActiveFilters.element", overridableId),
    filters: filters,
    removeActiveFilter: removeActiveFilter,
    getLabel: getLabel
  }, /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, filters.map((filter, index) => {
    const {
      label,
      activeFilter
    } = getLabel(filter);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default["default"].createElement(semanticUiReact.Label, {
        image: true,
        key: index,
        onClick: () => removeActiveFilter(activeFilter)
      }, label, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "delete"
      }))
    );
  })));
};
Element$g.defaultProps = {
  overridableId: ""
};
var ActiveFiltersComponent = Overridable__default["default"].component("ActiveFilters", ActiveFilters$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$b = dispatch => ({
  updateQueryFilters: filter => dispatch(updateQueryFilters(filter))
});
const ActiveFilters = reactRedux.connect(state => ({
  filters: state.query.filters
}), mapDispatchToProps$b)(ActiveFiltersComponent);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".AutoCompleteText{position:relative;z-index:100}.AutoCompleteText .input button,.AutoCompleteText .input input{border:none;border-radius:0}.AutoCompleteText ul{background-color:#fff;border:1px solid #e0e1e2;border-radius:0 0 .3rem .3rem;color:#000;list-style-type:none;margin:0;padding:0;position:absolute;text-align:left;width:100%}.AutoCompleteText ul:before{content:\"\"}.AutoCompleteText li{cursor:pointer;padding:.3em 1em}.AutoCompleteText li:hover{background-color:#e0e1e2;border-radius:.3rem;text-decoration:underline}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZpbGU6Ly8vaG9tZS9ydW5uZXIvd29yay9yZWFjdC1zZWFyY2hraXQvcmVhY3Qtc2VhcmNoa2l0L3NyYy9saWIvY29tcG9uZW50cy9BdXRvY29tcGxldGVTZWFyY2hCYXIvQXV0b2NvbXBsZXRlU2VhcmNoQmFyLnNjc3MiLCJBdXRvY29tcGxldGVTZWFyY2hCYXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxrQkFDRSxpQkFBQSxDQUNBLFdDQ0YsQ0RPQSwrREFDRSxXQUFBLENBQ0EsZUNDRixDREVBLHFCQU1FLHFCQUFBLENBR0Esd0JBQUEsQ0FDQSw2QkFBQSxDQUxBLFVBQUEsQ0FGQSxvQkFBQSxDQUlBLFFBQUEsQ0FDQSxTQUFBLENBTkEsaUJBQUEsQ0FFQSxlQUFBLENBSEEsVUNVRixDREVBLDRCQUNFLFVDQ0YsQ0RFQSxxQkFFRSxjQUFBLENBREEsZ0JDRUYsQ0RFQSwyQkFFRSx3QkFBQSxDQUNBLG1CQUFBLENBRkEseUJDR0YiLCJmaWxlIjoiQXV0b2NvbXBsZXRlU2VhcmNoQmFyLnNjc3MifQ== */";
styleInject(css_248z);

/* eslint-disable no-unused-vars */
class AutocompleteSearchBar$1 extends React.Component {
  constructor(props) {
    super(props);
    this._handleAutocompleteChange = suggestionString => {
      if (suggestionString.length >= this.minCharsToAutocomplete) {
        this.updateSuggestions(suggestionString);
      }
    };
    this.onInputChange = async queryString => {
      await this.setState({
        currentValue: queryString
      });
      this.handleAutocompleteChange(this.state.currentValue);
    };
    this.executeSearch = () => {
      this.updateQueryString(this.state.currentValue);
    };
    this.updateQueryString = this.props.updateQueryString;
    this.updateSuggestions = this.props.debounce ? ___default["default"].debounce(this.props.updateSuggestions, this.props.debounceTime, {
      leading: true
    }) : this.props.updateSuggestions;
    this.clearSuggestions = this.props.clearSuggestions;
    this.minCharsToAutocomplete = this.props.minCharsToAutocomplete;
    this.state = {
      currentValue: this.props.queryString || ""
    };
    this.handleAutocompleteChange = props.handleAutocompleteChange || this._handleAutocompleteChange;
  }
  render() {
    const {
      placeholder,
      suggestions,
      overridableId
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(Element$f, {
      placeholder: placeholder,
      queryString: this.state.currentValue,
      querySuggestions: suggestions,
      onInputChange: this.onInputChange,
      executeSearch: this.executeSearch,
      overridableId: overridableId
    });
  }
}
AutocompleteSearchBar$1.defaultProps = {
  handleAutocompleteChange: null,
  placeholder: "Type something",
  minCharsToAutocomplete: 3,
  overridableId: ""
};
const AutocompleteSearchBarUncontrolled = props => /*#__PURE__*/React__default["default"].createElement(AutocompleteSearchBar$1, Object.assign({
  key: props.queryString
}, props));
const Element$f = _ref => {
  let {
    overridableId,
    placeholder,
    queryString,
    querySuggestions,
    onInputChange,
    executeSearch,
    ...props
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  const onBtnSearchClick = (event, input) => {
    executeSearch();
  };
  const onKeyPress = (event, input) => {
    if (event.key === "Enter") {
      executeSearch();
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], Object.assign({
    id: buildUID("AutocompleteSearchBar.element", overridableId)
  }, props), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "AutoCompleteText"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, {
    action: {
      content: "Search",
      onClick: onBtnSearchClick
    },
    fluid: true,
    placeholder: placeholder,
    onChange: (event, _ref2) => {
      let {
        value
      } = _ref2;
      onInputChange(value);
    },
    value: queryString,
    onKeyPress: onKeyPress
  }), /*#__PURE__*/React__default["default"].createElement(Suggestions, {
    querySuggestions: querySuggestions,
    overridableId: overridableId
  })));
};
const Suggestions = _ref3 => {
  let {
    overridableId,
    ...props
  } = _ref3;
  const {
    querySuggestions
  } = props;
  const {
    buildUID
  } = React.useContext(AppContext);
  const onSuggestionSelected = async suggestion => {
    await undefined.setState({
      currentValue: suggestion
    });
    undefined.clearSuggestions();
    undefined.executeSearch();
  };
  if (querySuggestions.length === 0) {
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], Object.assign({
    id: buildUID("AutocompleteSearchBar.suggestions", overridableId)
  }, props), /*#__PURE__*/React__default["default"].createElement("ul", null, querySuggestions.map(text => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    as: "li",
    onClick: () => onSuggestionSelected(text),
    key: text
  }, text))));
};
var AutocompleteSearchBarComponent = Overridable__default["default"].component("AutocompleteSearchBar", AutocompleteSearchBarUncontrolled);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$a = dispatch => ({
  updateQueryString: query => dispatch(updateQueryString(query)),
  updateSuggestions: query => dispatch(updateSuggestions(query)),
  clearSuggestions: () => dispatch(clearSuggestions())
});
const mapStateToProps = state => ({
  queryString: state.query.queryString,
  suggestions: state.query.suggestions
});
const AutocompleteSearchBar = reactRedux.connect(mapStateToProps, mapDispatchToProps$a)(AutocompleteSearchBarComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class BucketAggregationValues extends React.Component {
  constructor(props) {
    super(props);
    this._isSelected = (aggName, value, selectedFilters) => {
      // return True there is at least one filter that has this value
      return selectedFilters.filter(filter => filter[0] === aggName && filter[1] === value).length >= 1;
    };
    this.getChildAggCmps = (bucket, selectedFilters) => {
      const hasChildAggregation = this.childAgg && this.childAgg["aggName"] in bucket;
      let selectedChildFilters = [];
      if (hasChildAggregation) {
        const childBuckets = bucket[this.childAgg["aggName"]]["buckets"];
        selectedFilters.forEach(filter => {
          const isThisAggregation = filter[0] === this.aggName;
          const isThisValue = filter[1] === bucket.key;
          const hasChild = filter.length === 3;
          if (isThisAggregation && isThisValue && hasChild) {
            selectedChildFilters.push(filter[2]);
          }
        });
        const onFilterClicked = value => {
          this.onFilterClicked([this.aggName, bucket.key, value]);
        };
        return /*#__PURE__*/React__default["default"].createElement(BucketAggregationValues, {
          buckets: childBuckets,
          selectedFilters: selectedChildFilters,
          field: this.childAgg.field,
          aggName: this.childAgg.aggName,
          childAgg: this.childAgg.childAgg,
          onFilterClicked: onFilterClicked
        });
      }
      return null;
    };
    this.field = props.field;
    this.aggName = props.aggName;
    this.childAgg = props.childAgg;
    this.onFilterClicked = props.onFilterClicked;
  }
  render() {
    const {
      buckets,
      selectedFilters,
      overridableId
    } = this.props;
    const valuesCmp = buckets.map(bucket => {
      const keyField = bucket.key_as_string ? bucket.key_as_string : bucket.key;
      const isSelected = this._isSelected(this.aggName, keyField, selectedFilters);
      const onFilterClicked = value => {
        this.onFilterClicked([this.aggName, value]);
      };
      const getChildAggCmps = bucket => this.getChildAggCmps(bucket, selectedFilters);
      return /*#__PURE__*/React__default["default"].createElement(ValueElement, {
        key: bucket.key,
        bucket: bucket,
        keyField: keyField,
        isSelected: isSelected,
        onFilterClicked: onFilterClicked,
        getChildAggCmps: getChildAggCmps,
        overridableId: overridableId
      });
    });
    return /*#__PURE__*/React__default["default"].createElement(ContainerElement, {
      valuesCmp: valuesCmp,
      overridableId: overridableId
    });
  }
}
BucketAggregationValues.defaultProps = {
  childAgg: null,
  overridableId: ""
};
const ContainerElement = _ref => {
  let {
    valuesCmp,
    overridableId
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("BucketAggregationContainer.element", overridableId),
    valuesCmp: valuesCmp
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.List, null, valuesCmp));
};
ContainerElement.defaultProps = {
  overridableId: ""
};
const ValueElement = _ref2 => {
  let {
    bucket,
    isSelected,
    onFilterClicked,
    getChildAggCmps,
    overridableId,
    keyField
  } = _ref2;
  const {
    buildUID,
    nextComponentIndex
  } = React.useContext(AppContext);
  const label = bucket.label ? bucket.label : `${keyField} (${bucket.doc_count.toLocaleString("en-US")})`;
  const childAggCmps = getChildAggCmps(bucket);
  /* Note that the checkbox does not have any `id`. It used to have one, based on the value, and the issue
     was that, if the same value appeared more than once, react didn't like having two items with the same id,
     and clicking on the second would select the first one */
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("BucketAggregationValues.element", overridableId),
    bucket: bucket,
    label: label,
    onFilterClicked: onFilterClicked,
    isSelected: isSelected,
    childAggCmps: childAggCmps
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.List.Item, {
    key: bucket.key
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
    label: label,
    id: nextComponentIndex(),
    value: bucket.key,
    onClick: () => onFilterClicked(bucket.key),
    checked: isSelected
  }), childAggCmps));
};
ValueElement.defaultProps = {
  overridableId: ""
};
var BucketAggregationValues$1 = Overridable__default["default"].component("BucketAggregationValues", BucketAggregationValues);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class BucketAggregation$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onFilterClicked = filter => {
      this.updateQueryFilters(filter);
    };
    this._renderValues = (resultBuckets, selectedFilters) => {
      const {
        overridableId
      } = this.props;
      return /*#__PURE__*/React__default["default"].createElement(BucketAggregationValues$1, {
        buckets: resultBuckets,
        selectedFilters: selectedFilters,
        field: this.agg.field,
        aggName: this.agg.aggName,
        childAgg: this.agg.childAgg,
        onFilterClicked: this.onFilterClicked,
        overridableId: overridableId
      });
    };
    this._getSelectedFilters = userSelectionFilters => {
      // get selected filters for this field only
      return userSelectionFilters.filter(filter => filter[0] === this.agg.aggName);
    };
    this._getResultBuckets = resultsAggregations => {
      // get buckets of this field
      const thisAggs = _get__default["default"](resultsAggregations, this.agg.aggName, {});
      if ("buckets" in thisAggs) {
        if (!Array.isArray(thisAggs["buckets"])) {
          // buckets can be objects or arrays: convert to array if object
          // to keep it consistent
          thisAggs["buckets"] = Object.entries(thisAggs["buckets"]).map(_ref => {
            let [key, value] = _ref;
            return {
              ...value,
              key
            };
          });
        }
        return thisAggs["buckets"];
      }
      return [];
    };
    this.title = props.title;
    this.agg = props.agg;
    this.updateQueryFilters = props.updateQueryFilters;
  }
  render() {
    const {
      userSelectionFilters,
      resultsAggregations,
      overridableId,
      ...props
    } = this.props;
    const selectedFilters = this._getSelectedFilters(userSelectionFilters);
    const resultBuckets = this._getResultBuckets(resultsAggregations);
    const valuesCmp = resultBuckets.length ? this._renderValues(resultBuckets, selectedFilters) : null;
    return /*#__PURE__*/React__default["default"].createElement(Element$e, Object.assign({
      title: this.title,
      containerCmp: valuesCmp,
      overridableId: overridableId
    }, props));
  }
}
BucketAggregation$1.defaultProps = {
  overridableId: ""
};
const Element$e = _ref2 => {
  let {
    overridableId,
    agg,
    title,
    containerCmp,
    updateQueryFilters
  } = _ref2;
  const {
    buildUID
  } = React.useContext(AppContext);
  return containerCmp && /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("BucketAggregation.element", overridableId),
    agg: agg,
    title: title,
    containerCmp: containerCmp,
    updateQueryFilters: updateQueryFilters
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Header, null, title)), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Content, null, containerCmp)));
};
Element$e.defaultProps = {
  containerCmp: null,
  overridableId: ""
};
var BucketAggregationComponent = Overridable__default["default"].component("BucketAggregation", BucketAggregation$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$9 = dispatch => ({
  updateQueryFilters: filter => dispatch(updateQueryFilters(filter))
});
const BucketAggregation = reactRedux.connect(state => ({
  userSelectionFilters: state.query.filters,
  resultsAggregations: state.results.data.aggregations
}), mapDispatchToProps$9)(BucketAggregationComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class ShouldRender extends React.Component {
  render() {
    const {
      children,
      condition
    } = this.props;
    return condition ? children : null;
  }
}
ShouldRender.defaultProps = {
  condition: true
};
var ShouldRender$1 = Overridable__default["default"].component("ShouldRender", ShouldRender);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class Count$1 extends React.Component {
  render() {
    const {
      loading,
      totalResults,
      label,
      overridableId
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: !loading && totalResults > 0
    }, label(/*#__PURE__*/React__default["default"].createElement(Element$d, {
      totalResults: totalResults,
      overridableId: overridableId
    })));
  }
}
Count$1.defaultProps = {
  label: cmp => cmp,
  overridableId: ""
};
const Element$d = _ref => {
  let {
    totalResults,
    overridableId
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  const _overridableId = buildUID("Count.element", overridableId);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: _overridableId,
    totalResults: totalResults
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
    color: "blue"
  }, totalResults.toLocaleString("en-US")));
};
Element$d.defaultProps = {
  overridableId: ""
};
var CountComponent = Overridable__default["default"].component("Count", Count$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const Count = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total
}))(CountComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class EmptyResults$1 extends React.Component {
  constructor(props) {
    super(props);
    this.resetQuery = props.resetQuery;
  }
  render() {
    const {
      loading,
      totalResults,
      error,
      queryString,
      extraContent,
      overridableId,
      userSelectionFilters,
      ...props
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: !loading && _isEmpty__default["default"](error) && totalResults === 0
    }, /*#__PURE__*/React__default["default"].createElement(Element$c, Object.assign({}, props, {
      queryString: queryString,
      resetQuery: this.resetQuery,
      extraContent: extraContent,
      userSelectionFilters: userSelectionFilters,
      overridableId: overridableId
    })));
  }
}
EmptyResults$1.defaultProps = {
  queryString: "",
  extraContent: null,
  overridableId: ""
};
const Element$c = _ref => {
  let {
    overridableId,
    queryString,
    resetQuery,
    extraContent,
    userSelectionFilters
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("EmptyResults.element", overridableId),
    queryString: queryString,
    resetQuery: resetQuery,
    extraContent: extraContent,
    userSelectionFilters: userSelectionFilters
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Segment, {
    placeholder: true,
    textAlign: "center"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Header, {
    icon: true
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "search"
  }), "No results found!"), queryString && /*#__PURE__*/React__default["default"].createElement("em", null, "Current search \"", queryString, "\""), /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
    primary: true,
    onClick: () => resetQuery()
  }, "Clear query"), extraContent));
};
Element$c.defaultProps = {
  queryString: "",
  extraContent: null,
  overridableId: ""
};
var EmptyResultsComponent = Overridable__default["default"].component("EmptyResults", EmptyResults$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$8 = dispatch => ({
  resetQuery: () => dispatch(resetQuery())
});
const EmptyResults = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total,
  error: state.results.error,
  queryString: state.query.queryString,
  userSelectionFilters: state.query.filters
}), mapDispatchToProps$8)(EmptyResultsComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function Error$2(_ref) {
  let {
    loading,
    error,
    overridableId
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
    condition: !loading && !_isEmpty__default["default"](error)
  }, /*#__PURE__*/React__default["default"].createElement(Element$b, {
    error: error,
    overridableId: overridableId
  }));
}
Error$2.defaultProps = {
  overridableId: ""
};
const Element$b = _ref2 => {
  let {
    error,
    overridableId
  } = _ref2;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("Error.element", overridableId),
    error: error
  }, /*#__PURE__*/React__default["default"].createElement("div", null, "Oops! Something went wrong while fetching results."));
};
Element$b.defaultProps = {
  overridableId: ""
};
var ErrorComponent = Overridable__default["default"].component("Error", Error$2);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const Error$1 = reactRedux.connect(state => ({
  loading: state.results.loading,
  error: state.results.error
}))(ErrorComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2019-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function withState(Component) {
  const WrappedComponent = props => /*#__PURE__*/React__default["default"].createElement(Component, props);
  const mapStateToProps = state => ({
    currentQueryState: state.query,
    currentResultsState: state.results
  });
  const mapDispatchToProps = dispatch => ({
    updateQueryState: queryState => dispatch(updateQueryState(queryState))
  });
  return reactRedux.connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
}

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class LayoutSwitcher$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onLayoutChange = layoutName => {
      this.updateLayout(layoutName);
    };
    this.updateLayout = props.updateLayout;
  }
  render() {
    const {
      currentLayout,
      loading,
      totalResults,
      overridableId
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: currentLayout !== null && !loading && totalResults > 0
    }, /*#__PURE__*/React__default["default"].createElement(Element$a, {
      currentLayout: currentLayout,
      onLayoutChange: this.onLayoutChange,
      overridableId: overridableId
    }));
  }
}
LayoutSwitcher$1.defaultProps = {
  currentLayout: null,
  overridableId: ""
};
const Element$a = _ref => {
  let {
    overridableId,
    currentLayout,
    onLayoutChange
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("LayoutSwitcher.element", overridableId),
    currentLayout: currentLayout,
    onLayoutChange: onLayoutChange
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Menu, {
    compact: true,
    icon: true
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Menu.Item, {
    name: "list",
    active: currentLayout === "list",
    onClick: (_, _ref2) => {
      let {
        name
      } = _ref2;
      return onLayoutChange(name);
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "list layout"
  })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Menu.Item, {
    name: "grid",
    active: currentLayout === "grid",
    onClick: (_, _ref3) => {
      let {
        name
      } = _ref3;
      return onLayoutChange(name);
    }
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
    name: "grid layout"
  }))));
};
Element$a.defaultProps = {
  currentLayout: null,
  overridableId: ""
};
var LayoutSwitcherComponent = Overridable__default["default"].component("LayoutSwitcher", LayoutSwitcher$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$7 = dispatch => ({
  updateLayout: layout => dispatch(updateResultsLayout(layout))
});
const LayoutSwitcher = reactRedux.connect(state => ({
  loading: state.results.loading,
  currentLayout: state.query.layout,
  totalResults: state.results.data.total
}), mapDispatchToProps$7)(LayoutSwitcherComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const defaultOptions = {
  boundaryRangeCount: 1,
  siblingRangeCount: 1,
  showEllipsis: true,
  showFirst: true,
  showLast: true,
  showPrev: true,
  showNext: true,
  size: "large"
};
class Pagination$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onPageChange = activePage => {
      const {
        currentPage
      } = this.props;
      if (activePage === currentPage) return;
      this.updateQueryPage(activePage);
    };
    this.updateQueryPage = props.updateQueryPage;
    this.options = props.options ? {
      ...defaultOptions,
      ...props.options
    } : defaultOptions;
  }
  render() {
    const {
      loading,
      totalResults,
      currentPage,
      currentSize,
      overridableId,
      showWhenOnlyOnePage
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: !loading && currentPage > -1 && currentSize > -1 && showWhenOnlyOnePage ? totalResults > 0 : totalResults > currentSize
    }, /*#__PURE__*/React__default["default"].createElement(Element$9, {
      currentPage: currentPage,
      currentSize: currentSize,
      totalResults: totalResults,
      onPageChange: this.onPageChange,
      options: this.options,
      overridableId: overridableId,
      maxTotalResults: this.options.maxTotalResults
    }));
  }
}
Pagination$1.defaultProps = {
  options: {},
  overridableId: "",
  showWhenOnlyOnePage: true
};
const Element$9 = _ref => {
  let {
    overridableId,
    currentPage,
    currentSize,
    totalResults,
    onPageChange,
    options,
    maxTotalResults,
    ...props
  } = _ref;
  const boundaryRangeCount = options.boundaryRangeCount;
  const siblingRangeCount = options.siblingRangeCount;
  const showEllipsis = options.showEllipsis;
  const showFirst = options.showFirst;
  const showLast = options.showLast;
  const showPrev = options.showPrev;
  const showNext = options.showNext;
  const size = options.size;
  const maxTotalPages = Math.floor(maxTotalResults / currentSize);
  const pages = Math.ceil(totalResults / currentSize);
  const totalDisplayedPages = Math.min(pages, maxTotalPages);
  const {
    buildUID
  } = React.useContext(AppContext);
  if (currentPage > pages) onPageChange(pages);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("Pagination.element", overridableId),
    currentPage: currentPage,
    currentSize: currentSize,
    totalResults: totalResults,
    options: options,
    onPageChange: onPageChange
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Pagination, Object.assign({
    activePage: currentPage,
    totalPages: totalDisplayedPages,
    onPageChange: (_, _ref2) => {
      let {
        activePage
      } = _ref2;
      return onPageChange(activePage);
    },
    boundaryRange: boundaryRangeCount,
    siblingRange: siblingRangeCount,
    ellipsisItem: showEllipsis ? undefined : null,
    firstItem: showFirst ? undefined : null,
    lastItem: showLast ? undefined : null,
    prevItem: showPrev ? undefined : null,
    nextItem: showNext ? undefined : null,
    size: size
  }, props)));
};
Element$9.defaultProps = {
  options: {},
  overridableId: "",
  maxTotalResults: 10000
};
var PaginationComponent = Overridable__default["default"].component("Pagination", Pagination$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$6 = dispatch => ({
  updateQueryPage: page => dispatch(updateQueryPaginationPage(page))
});
const Pagination = reactRedux.connect(state => ({
  currentPage: state.query.page,
  currentSize: state.query.size,
  loading: state.results.loading,
  totalResults: state.results.data.total
}), mapDispatchToProps$6)(PaginationComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function ResultsGrid$1(_ref) {
  let {
    loading,
    totalResults,
    results,
    resultsPerRow,
    overridableId,
    onResultsRendered
  } = _ref;
  React.useEffect(() => {
    if (onResultsRendered) {
      onResultsRendered();
    }
  }, [onResultsRendered]);
  return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
    condition: !loading && totalResults > 0
  }, /*#__PURE__*/React__default["default"].createElement(Element$8, {
    results: results,
    resultsPerRow: resultsPerRow,
    overridableId: overridableId
  }));
}
ResultsGrid$1.defaultProps = {
  resultsPerRow: 3,
  overridableId: "",
  onResultsRendered: () => {}
};
const GridItem = _ref2 => {
  let {
    result,
    overridableId
  } = _ref2;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsGrid.item", overridableId),
    result: result
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card, {
    fluid: true,
    href: `#${result.id}`
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Image, {
    src: result.imgSrc || "http://placehold.it/200"
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Header, null, result.title), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Description, null, result.description))));
};
const Element$8 = _ref3 => {
  let {
    overridableId,
    results,
    resultsPerRow
  } = _ref3;
  const {
    buildUID
  } = React.useContext(AppContext);
  const _results = results.map((result, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default["default"].createElement(GridItem, {
    key: index,
    result: result,
    overridableId: overridableId
  }));
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsGrid.container", overridableId),
    results: _results,
    resultsPerRow: resultsPerRow
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Group, {
    itemsPerRow: resultsPerRow
  }, _results));
};
Element$8.defaultProps = {
  resultsPerRow: 3,
  overridableId: ""
};
var ResultsGridComponent = Overridable__default["default"].component("ResultsGrid", ResultsGrid$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const ResultsGrid = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total,
  results: state.results.data.hits
}))(ResultsGridComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function ResultsList$1(_ref) {
  let {
    loading,
    totalResults,
    results,
    overridableId,
    onResultsRendered
  } = _ref;
  React.useEffect(() => {
    if (onResultsRendered) {
      onResultsRendered();
    }
  }, [onResultsRendered]);
  return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
    condition: !loading && totalResults > 0
  }, /*#__PURE__*/React__default["default"].createElement(Element$7, {
    results: results,
    overridableId: overridableId
  }));
}
ResultsList$1.defaultProps = {
  overridableId: "",
  onResultsRendered: () => {}
};
const ListItem = _ref2 => {
  let {
    result,
    overridableId
  } = _ref2;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsList.item", overridableId),
    result: result
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item, {
    href: `#${result.id}`
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Image, {
    size: "small",
    src: result.imgSrc || "http://placehold.it/200"
  }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Header, null, result.title), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Description, null, result.description))));
};
const Element$7 = _ref3 => {
  let {
    results,
    overridableId
  } = _ref3;
  const {
    buildUID
  } = React.useContext(AppContext);
  const _results = results.map((result, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default["default"].createElement(ListItem, {
    result: result,
    key: index,
    overridableId: overridableId
  }));
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsList.container", overridableId),
    results: _results
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Group, {
    divided: true,
    relaxed: true,
    link: true
  }, _results));
};
Element$7.defaultProps = {
  overridableId: ""
};
var ResultsListComponent = Overridable__default["default"].component("ResultsList", ResultsList$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const ResultsList = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total,
  results: state.results.data.hits
}))(ResultsListComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function ResultsLoader$1(_ref) {
  let {
    children,
    loading,
    overridableId
  } = _ref;
  return loading ? /*#__PURE__*/React__default["default"].createElement(Element$6, {
    overridableId: overridableId
  }) : children;
}
ResultsLoader$1.defaultProps = {
  overridableId: ""
};
const Element$6 = _ref2 => {
  let {
    overridableId
  } = _ref2;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsLoader.element", overridableId)
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Loader, {
    active: true,
    size: "huge",
    inline: "centered"
  }));
};
Element$6.defaultProps = {
  overridableId: ""
};
var ResultsLoaderComponent = Overridable__default["default"].component("ResultsLoader", ResultsLoader$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const ResultsLoader = reactRedux.connect(state => ({
  loading: state.results.loading
}))(ResultsLoaderComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
function ResultsMultiLayout$1(_ref) {
  let {
    loading,
    totalResults,
    currentLayout,
    overridableId,
    onResultsRendered
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
    condition: currentLayout != null && !loading && totalResults > 0
  }, /*#__PURE__*/React__default["default"].createElement(Element$5, {
    layout: currentLayout,
    overridableId: overridableId,
    onResultsRendered: onResultsRendered
  }));
}
ResultsMultiLayout$1.defaultProps = {
  currentLayout: null,
  overridableId: "",
  onResultsRendered: () => {}
};
const Element$5 = _ref2 => {
  let {
    layout,
    overridableId,
    onResultsRendered
  } = _ref2;
  const {
    buildUID
  } = React.useContext(AppContext);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsMultiLayout.element", overridableId),
    layout: layout,
    onResultsRendered: onResultsRendered
  }, layout === "list" ? /*#__PURE__*/React__default["default"].createElement(ResultsList, {
    overridableId: overridableId,
    onResultsRendered: onResultsRendered
  }) : /*#__PURE__*/React__default["default"].createElement(ResultsGrid, {
    overridableId: overridableId,
    onResultsRendered: onResultsRendered
  }));
};
Element$5.defaultProps = {
  layout: "",
  overridableId: "",
  onResultsRendered: () => {}
};
var ResultsMultiLayoutComponent = Overridable__default["default"].component("ResultsMultiLayout", ResultsMultiLayout$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const ResultsMultiLayout = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total,
  currentLayout: state.query.layout
}))(ResultsMultiLayoutComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 * Copyright (C) 2022 NYU.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class ResultsPerPage$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = value => {
      const {
        currentSize
      } = this.props;
      if (value === currentSize) return;
      this.updateQuerySize(value);
    };
    this.options = props.values;
    this.updateQuerySize = props.updateQuerySize;
  }
  render() {
    const {
      loading,
      currentSize,
      totalResults,
      label,
      overridableId,
      ariaLabel,
      selectOnNavigation,
      showWhenOnlyOnePage
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: !loading && currentSize !== -1 && showWhenOnlyOnePage ? totalResults > 0 : totalResults > currentSize
    }, label(/*#__PURE__*/React__default["default"].createElement(Element$4, {
      currentSize: currentSize,
      options: this.options,
      onValueChange: this.onChange,
      overridableId: overridableId,
      ariaLabel: ariaLabel,
      selectOnNavigation: selectOnNavigation
    })));
  }
}
ResultsPerPage$1.defaultProps = {
  label: cmp => cmp,
  overridableId: "",
  ariaLabel: "Results per page",
  selectOnNavigation: false,
  showWhenOnlyOnePage: true
};
const Element$4 = _ref => {
  let {
    overridableId,
    currentSize,
    options,
    onValueChange,
    ariaLabel,
    selectOnNavigation
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  const _options = options.map((element, index) => {
    return {
      key: index,
      text: element.text,
      value: element.value
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("ResultsPerPage.element", overridableId),
    currentSize: currentSize,
    options: options,
    onValueChange: onValueChange,
    ariaLabel: ariaLabel,
    selectOnNavigation: selectOnNavigation
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
    inline: true,
    compact: true,
    options: _options,
    value: currentSize,
    onChange: (e, _ref2) => {
      let {
        value
      } = _ref2;
      return onValueChange(value);
    },
    "aria-label": ariaLabel,
    selectOnNavigation: selectOnNavigation
  }));
};
Element$4.defaultProps = {
  ariaLabel: "Results per page",
  selectOnNavigation: false,
  overridableId: ""
};
var ResultsPerPageComponent = Overridable__default["default"].component("ResultsPerPage", ResultsPerPage$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$5 = dispatch => ({
  updateQuerySize: size => dispatch(updateQueryPaginationSize(size))
});
const ResultsPerPage = reactRedux.connect(state => ({
  loading: state.results.loading,
  currentSize: state.query.size,
  totalResults: state.results.data.total
}), mapDispatchToProps$5)(ResultsPerPageComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class SearchBar$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = queryString => {
      this.setState({
        currentValue: queryString
      });
    };
    this.executeSearch = () => {
      const {
        currentValue
      } = this.state;
      this.updateQueryString(currentValue);
    };
    this.onBtnSearchClick = () => {
      this.executeSearch();
    };
    this.onKeyPress = event => {
      if (event.key === "Enter") {
        this.executeSearch();
      }
    };
    this.updateQueryString = props.updateQueryString;
    this.state = {
      currentValue: props.queryString || ""
    };
  }
  render() {
    const {
      actionProps,
      autofocus,
      executeSearch,
      onBtnSearchClick,
      onInputChange,
      onKeyPress,
      overridableId,
      placeholder,
      uiProps
    } = this.props;
    const {
      currentValue
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(Element$3, {
      actionProps: actionProps,
      autofocus: autofocus,
      executeSearch: executeSearch || this.executeSearch,
      onBtnSearchClick: onBtnSearchClick || this.onBtnSearchClick,
      onInputChange: onInputChange || this.onInputChange,
      onKeyPress: onKeyPress || this.onKeyPress,
      overridableId: overridableId,
      placeholder: placeholder,
      queryString: currentValue,
      uiProps: uiProps
    });
  }
}
SearchBar$1.defaultProps = {
  actionProps: null,
  autofocus: false,
  executeSearch: null,
  onBtnSearchClick: null,
  onInputChange: null,
  onKeyPress: null,
  overridableId: "",
  placeholder: "",
  queryString: "",
  uiProps: null
};

// NOTE: Adding the key prop, will recreate the SearchBar in order to update
// state with the latest redux queryString value.
// https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
const SearchBarUncontrolled = props => {
  const {
    queryString
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(SearchBar$1, Object.assign({
    key: queryString
  }, props));
};
SearchBarUncontrolled.defaultProps = {
  queryString: ""
};
class Element$3 extends React.Component {
  componentDidMount() {
    const {
      autofocus
    } = this.props;
    if (autofocus && this.focusInput) {
      this.focusInput.focus();
    }
  }
  render() {
    const {
      actionProps,
      onBtnSearchClick,
      onInputChange,
      onKeyPress,
      overridableId,
      placeholder,
      queryString,
      uiProps
    } = this.props;
    const {
      buildUID
    } = this.context;
    return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
      id: buildUID("SearchBar.element", overridableId),
      queryString: queryString,
      onBtnSearchClick: onBtnSearchClick,
      onInputChange: onInputChange,
      onKeyPress: onKeyPress,
      placeholder: placeholder,
      actionProps: actionProps,
      uiProps: uiProps
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, Object.assign({
      action: {
        content: "Search",
        onClick: onBtnSearchClick,
        ...actionProps
      },
      fluid: true
    }, uiProps, {
      placeholder: placeholder || "Type something",
      onChange: (_, _ref) => {
        let {
          value
        } = _ref;
        onInputChange(value);
      },
      value: queryString,
      onKeyPress: onKeyPress,
      ref: input => {
        this.focusInput = input;
      }
    })));
  }
}
Element$3.defaultProps = {
  actionProps: null,
  autofocus: false,
  onBtnSearchClick: null,
  onInputChange: null,
  onKeyPress: null,
  overridableId: "",
  placeholder: "",
  queryString: "",
  uiProps: null
};
Element$3.contextType = AppContext;
var SearchBarComponent = Overridable__default["default"].component("SearchBar", SearchBarUncontrolled);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$4 = dispatch => ({
  updateQueryString: query => dispatch(updateQueryString(query))
});
const SearchBar = reactRedux.connect(state => ({
  queryString: state.query.queryString
}), mapDispatchToProps$4)(SearchBarComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 * Copyright (C) 2022 NYU.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class Sort$1 extends React.Component {
  constructor(props) {
    super(props);
    this._computeValue = (sortBy, sortOrder) => {
      return sortOrder ? `${sortBy}-${sortOrder}` : sortBy;
    };
    this.onChange = value => {
      const {
        currentSortBy,
        currentSortOrder
      } = this.props;
      if (value === this._computeValue(currentSortBy, currentSortOrder)) return;
      const selected = this.options.find(option => option.value === value);
      this.updateQuerySorting(selected.sortBy, selected.sortOrder);
    };
    this.options = props.values;
    this.updateQuerySorting = props.updateQuerySorting;
    this.options.forEach(option => option["value"] = this._computeValue(option.sortBy, option.sortOrder));
  }
  render() {
    const {
      currentSortBy,
      currentSortOrder,
      loading,
      totalResults,
      label,
      overridableId,
      sortOrderDisabled,
      ariaLabel,
      selectOnNavigation
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: currentSortBy !== null && (sortOrderDisabled || currentSortBy !== null) && !loading && totalResults > 0
    }, label(/*#__PURE__*/React__default["default"].createElement(Element$2, {
      currentSortBy: currentSortBy,
      currentSortOrder: currentSortOrder,
      options: this.options,
      onValueChange: this.onChange,
      computeValue: this._computeValue,
      overridableId: overridableId,
      ariaLabel: ariaLabel,
      selectOnNavigation: selectOnNavigation
    })));
  }
}
Sort$1.defaultProps = {
  currentSortBy: null,
  currentSortOrder: null,
  label: cmp => cmp,
  overridableId: "",
  sortOrderDisabled: false,
  ariaLabel: "Sort",
  selectOnNavigation: false
};
const Element$2 = _ref => {
  let {
    overridableId,
    currentSortBy,
    currentSortOrder,
    options,
    onValueChange,
    computeValue,
    ariaLabel,
    selectOnNavigation
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  const selected = computeValue(currentSortBy, currentSortOrder);
  const _options = options.map((element, index) => {
    return {
      key: index,
      text: element.text,
      value: element.value
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("Sort.element", overridableId),
    options: options,
    currentSortBy: currentSortBy,
    currentSortOrder: currentSortOrder,
    onValueChange: onValueChange,
    ariaLabel: ariaLabel,
    selectOnNavigation: selectOnNavigation
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
    selection: true,
    options: _options,
    value: selected,
    onChange: (e, _ref2) => {
      let {
        value
      } = _ref2;
      return onValueChange(value);
    },
    "aria-label": ariaLabel,
    selectOnNavigation: selectOnNavigation
  }));
};
Element$2.defaultProps = {
  currentSortBy: null,
  currentSortOrder: null,
  overridableId: "",
  ariaLabel: "Sort",
  selectOnNavigation: false
};
var SortComponent = Overridable__default["default"].component("Sort", Sort$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$3 = dispatch => ({
  updateQuerySorting: (sortBy, sortOrder) => dispatch(updateQuerySorting(sortBy, sortOrder))
});
const Sort = reactRedux.connect(state => ({
  currentSortBy: state.query.sortBy,
  currentSortOrder: state.query.sortOrder,
  loading: state.results.loading,
  totalResults: state.results.data.total
}), mapDispatchToProps$3)(SortComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 * Copyright (C) 2022 NYU.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class SortBy$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = value => {
      const {
        currentSortBy
      } = this.props;
      if (value === currentSortBy) return;
      this.updateQuerySortBy(value);
    };
    this.options = props.values;
    this.updateQuerySortBy = props.updateQuerySortBy;
  }
  render() {
    const {
      currentSortBy,
      loading,
      totalResults,
      label,
      overridableId,
      ariaLabel,
      selectOnNavigation
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: currentSortBy !== null && !loading && totalResults > 0
    }, label(/*#__PURE__*/React__default["default"].createElement(Element$1, {
      currentSortBy: currentSortBy,
      options: this.options,
      onValueChange: this.onChange,
      overridableId: overridableId,
      ariaLabel: ariaLabel,
      selectOnNavigation: selectOnNavigation
    })));
  }
}
SortBy$1.defaultProps = {
  currentSortBy: null,
  label: cmp => cmp,
  overridableId: "",
  ariaLabel: "Sort Results By",
  selectOnNavigation: false
};
const Element$1 = _ref => {
  let {
    overridableId,
    currentSortBy,
    options,
    onValueChange,
    ariaLabel,
    selectOnNavigation
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  const _options = options.map((element, index) => {
    return {
      key: index,
      text: element.text,
      value: element.value
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("SortBy.element", overridableId),
    options: options,
    currentSortBy: currentSortBy,
    onValueChange: onValueChange,
    ariaLabel: ariaLabel,
    selectOnNavigation: selectOnNavigation
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
    selection: true,
    compact: true,
    options: _options,
    value: currentSortBy,
    onChange: (_, _ref2) => {
      let {
        value
      } = _ref2;
      return onValueChange(value);
    },
    "aria-label": ariaLabel,
    selectOnNavigation: selectOnNavigation
  }));
};
Element$1.defaultProps = {
  currentSortBy: null,
  overridableId: "",
  ariaLabel: "Sort Results By",
  selectOnNavigation: false
};
var SortByComponent = Overridable__default["default"].component("SortBy", SortBy$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$2 = dispatch => ({
  updateQuerySortBy: sortByValue => dispatch(updateQuerySortBy(sortByValue))
});
const SortBy = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total,
  currentSortBy: state.query.sortBy
}), mapDispatchToProps$2)(SortByComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2022 CERN.
 * Copyright (C) 2022 NYU.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class SortOrder$1 extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = value => {
      const {
        currentSortOrder
      } = this.props;
      if (value === currentSortOrder) return;
      this.updateQuerySortOrder(value);
    };
    this.options = props.values;
    this.updateQuerySortOrder = props.updateQuerySortOrder;
  }
  render() {
    const {
      currentSortOrder,
      loading,
      totalResults,
      label,
      overridableId,
      ariaLabel,
      selectOnNavigation
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ShouldRender$1, {
      condition: currentSortOrder !== null && !loading && totalResults > 0
    }, label(/*#__PURE__*/React__default["default"].createElement(Element, {
      currentSortOrder: currentSortOrder,
      options: this.options,
      onValueChange: this.onChange,
      overridableId: overridableId,
      ariaLabel: ariaLabel,
      selectOnNavigation: selectOnNavigation
    })));
  }
}
SortOrder$1.defaultProps = {
  currentSortOrder: null,
  label: cmp => cmp,
  overridableId: "",
  ariaLabel: "Sort Order",
  selectOnNavigation: false
};
const Element = _ref => {
  let {
    overridableId,
    currentSortOrder,
    options,
    onValueChange,
    ariaLabel,
    selectOnNavigation
  } = _ref;
  const {
    buildUID
  } = React.useContext(AppContext);
  const _options = options.map((element, index) => {
    return {
      key: index,
      text: element.text,
      value: element.value
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("SortOrder.element", overridableId),
    options: options,
    currentSortOrder: currentSortOrder,
    onValueChange: onValueChange,
    ariaLabel: ariaLabel,
    selectOnNavigation: selectOnNavigation
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
    selection: true,
    compact: true,
    options: _options,
    value: currentSortOrder,
    onChange: (_, _ref2) => {
      let {
        value
      } = _ref2;
      return onValueChange(value);
    },
    "aria-label": ariaLabel,
    selectOnNavigation: selectOnNavigation
  }));
};
Element.defaultProps = {
  currentSortOrder: null,
  overridableId: "",
  ariaLabel: "Sort Order",
  selectOnNavigation: false
};
var SortOrderComponent = Overridable__default["default"].component("SortOrder", SortOrder$1);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2018-2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps$1 = dispatch => ({
  updateQuerySortOrder: sortOrderValue => dispatch(updateQuerySortOrder(sortOrderValue))
});
const SortOrder = reactRedux.connect(state => ({
  loading: state.results.loading,
  totalResults: state.results.data.total,
  currentSortOrder: state.query.sortOrder
}), mapDispatchToProps$1)(SortOrderComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020-2022 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const ToggleComponent = _ref => {
  let {
    overridableId,
    userSelectionFilters,
    title,
    label,
    filterValue,
    updateQueryFilters
  } = _ref;
  const _isChecked = userSelectionFilters => {
    const isFilterActive = userSelectionFilters.filter(filter => filter[0] === filterValue[0]).length > 0;
    return isFilterActive;
  };
  const onClick = () => {
    updateQueryFilters(filterValue);
  };
  const {
    buildUID
  } = React.useContext(AppContext);
  const isChecked = _isChecked(userSelectionFilters);
  return /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
    id: buildUID("SearchFilters.Toggle.element", overridableId),
    title: title,
    label: label,
    filterValue: filterValue,
    userSelectionFilters: userSelectionFilters,
    updateQueryFilters: updateQueryFilters
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Header, null, title)), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Card.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
    toggle: true,
    label: label,
    onClick: onClick,
    checked: isChecked
  }))));
};
ToggleComponent.defaultProps = {
  overridableId: ""
};
var ToggleComponent$1 = Overridable__default["default"].component("SearchFilters.Toggle", ToggleComponent);

/*
 * This file is part of React-SearchKit.
 * Copyright (C) 2020 CERN.
 *
 * React-SearchKit is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
const mapDispatchToProps = dispatch => ({
  updateQueryFilters: filter => dispatch(updateQueryFilters(filter))
});
const Toggle = reactRedux.connect(state => ({
  userSelectionFilters: state.query.filters
}), mapDispatchToProps)(ToggleComponent$1);

const onQueryChanged = payload => {
  var evt = new CustomEvent("queryChanged", {
    detail: payload
  });
  window.dispatchEvent(evt);
};

exports.ActiveFilters = ActiveFilters;
exports.AppContext = AppContext;
exports.AutocompleteSearchBar = AutocompleteSearchBar;
exports.BucketAggregation = BucketAggregation;
exports.Count = Count;
exports.ESRequestSerializer = ESRequestSerializer;
exports.ESResponseSerializer = ESResponseSerializer;
exports.ESSearchApi = ESSearchApi;
exports.EmptyResults = EmptyResults;
exports.Error = Error$1;
exports.InvenioRecordsResourcesRequestSerializer = InvenioRecordsResourcesRequestSerializer;
exports.InvenioRequestSerializer = InvenioRequestSerializer;
exports.InvenioResponseSerializer = InvenioResponseSerializer;
exports.InvenioSearchApi = InvenioSearchApi;
exports.InvenioSuggestionApi = InvenioSuggestionApi;
exports.LayoutSwitcher = LayoutSwitcher;
exports.Pagination = Pagination;
exports.ReactSearchKit = ReactSearchKit$1;
exports.RequestCancelledError = RequestCancelledError;
exports.ResultsGrid = ResultsGrid;
exports.ResultsList = ResultsList;
exports.ResultsLoader = ResultsLoader;
exports.ResultsMultiLayout = ResultsMultiLayout;
exports.ResultsPerPage = ResultsPerPage;
exports.SearchBar = SearchBar;
exports.Sort = Sort;
exports.SortBy = SortBy;
exports.SortOrder = SortOrder;
exports.Toggle = Toggle;
exports.UrlHandlerApi = UrlHandlerApi;
exports.UrlParamValidator = UrlParamValidator;
exports.buildUID = buildUID;
exports.createStoreWithConfig = createStoreWithConfig;
exports.onQueryChanged = onQueryChanged;
exports.withState = withState;
//# sourceMappingURL=index.js.map
